import React, { Suspense, useMemo, useState } from 'react';

import Breadcrumbs from 'components/breadcrumbs';

import FileSharingTabHeader from './components/file-sharing-tab-header';
import FileView from './components/file-view';
import FolderView from './components/folder-view';
import { useFolder } from './hooks/use-folder';
import Paper from 'components/paper';

type FileSharing = {};

const FileSharing: React.FC<FileSharing> = () => {
  const [selectedFolderId, setSelectedFolderId] = useState<string>('');

  const { data: folder, isLoading } = useFolder({ selectedFolderId: selectedFolderId ?? '' });

  const fileList = useMemo(() => {
    return folder?.files;
  }, [folder]);

  // #region HANDLERS

  const handleFolderId = (folderId: string) => {
    setSelectedFolderId(folderId ?? '');
  };

  // #endregion HANDLERS

  return (
    <>
      <FileSharingTabHeader utils={<Breadcrumbs />} />
      <Suspense fallback={isLoading}>
        <Paper transparent sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <FolderView folder={folder} selectFolderId={handleFolderId} />
          <FileView fileList={fileList} isLoading={isLoading} />
        </Paper>
      </Suspense>
    </>
  );
};

export default React.memo(FileSharing);
